import React, { useState } from "react";
import { DownloadSimple, TelegramLogo } from "@phosphor-icons/react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { api } from "../lib/api";
import { formatApiError } from "../lib/auth";

export function CmtExportButtons({ links, selectedIds }) {
  const [sending, setSending] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const ids = links.filter((l) => selectedIds.has(l.id)).map((l) => l.id);

  const download = async () => {
    setDownloading(true);
    let codes = [];
    let missing = 0;
    try {
      const res = await api.post("/admin/tracker/links/cmt-numbers", { ids });
      codes = res.data.codes;
      missing = res.data.missing;
    } catch (e) {
      toast.error(formatApiError(e) || "No se pudieron obtener los CMT");
    }
    setDownloading(false);
    if (!codes.length) return toast.error("No pude obtener el número de trámite (CMT) de los seleccionados");
    const blob = new Blob([codes.join("\n") + "\n"], { type: "text/plain;charset=utf-8" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `CMT_${new Date().toISOString().slice(0, 10)}_${codes.length}.txt`;
    a.click();
    URL.revokeObjectURL(a.href);
    toast.success(`${codes.length} CMT descargados${missing ? ` · ${missing} sin CMT` : ""}`);
  };

  const sendTelegram = async () => {
    setSending(true);
    try {
      const res = await api.post("/admin/tracker/links/export-telegram", { ids });
      toast.success(`${res.data.count} CMT enviados a Telegram${res.data.missing ? ` · ${res.data.missing} sin CMT` : ""}`);
    } catch (e) {
      toast.error(formatApiError(e) || "No se pudo enviar");
    }
    setSending(false);
  };

  const cls = "rounded-none text-white font-bold uppercase text-[10px] tracking-wider h-7";
  return (
    <>
      <Button onClick={download} disabled={downloading} size="sm" data-testid="tracker-export-txt-button" className={`${cls} bg-[#002FA7] hover:bg-[#00227a]`}>
        <DownloadSimple size={12} weight="bold" className="mr-1" /> {downloading ? "Buscando..." : `TXT (${ids.length})`}
      </Button>
      <Button onClick={sendTelegram} disabled={sending} size="sm" data-testid="tracker-export-telegram-button" className={`${cls} bg-[#0088cc] hover:bg-[#006ba6]`}>
        <TelegramLogo size={12} weight="bold" className="mr-1" /> {sending ? "Enviando..." : "Telegram"}
      </Button>
    </>
  );
}
